import { request, success, failure, FILE } from "./utilities";
import { getFile } from "../api";
import { FileData } from "../../utils/dummyData";
import {
  addAndRemoveFromMyFavFileApi,
  addAndRemoveFromMyFavFolderApi,
  addFileListApi,
  addFolderListApi,
  deleteFileApi,
  deleteFolderApi,
  getDeletedFileListApi,
  getDeletedFolderListApi,
  getFavoriteFileListApi,
  getFavoriteFolderListApi,
  getFilesListApi,
  getFolderListApi,
  getRecentFileListApi,
  getRecentFolderListApi,
} from "../api/filesApi";

export function getAllFolderList(data, token) {
  return (dispatch) => {
    // dispatch(success(FILE.GET_FILE_SUCCESS, FileData));
    dispatch(request(FILE.GET_FOLDER_REQUEST));
    getFolderListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_FOLDER_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_FOLDER_FAILURE, res.data.data));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// export function addfile(data) {
//   return (dispatch) => {
//     dispatch(request(FILE.ADD_FILE_REQUEST));
//     addfile(data).then(
//       (res) => {
//         if (res.data.status === 1) {
//           dispatch(success(FILE.ADD_FILE_SUCCESS, res.data.data));
//         } else {
//           dispatch(failure(FILE.ADD_FILE_FAILURE, res.data.message));
//         }
//       },
//       (error) => {
//         dispatch(
//           failure(
//             FILE.ADD_FILE_FAILURE,
//             error &&
//               error.response &&
//               error.response.data &&
//               error.response.data.title
//               ? error.response.data.title
//               : error.message
//           )
//         );
//       }
//     );
//   };
// }
export function addFolderList(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(FILE.ADD_FOLDER_REQUEST));
    addFolderListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.ADD_FOLDER_SUCCESS, res.data.data));
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(failure(FILE.ADD_FOLDER_FAILURE, res.data.message));
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.ADD_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getRecentFolderList(data, token) {
  return (dispatch) => {
    dispatch(request(FILE.GET_RECENT_FOLDER_REQUEST));
    getRecentFolderListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_RECENT_FOLDER_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_RECENT_FOLDER_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_RECENT_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getFavoriteFolderList(data, token) {
  return (dispatch) => {
    dispatch(request(FILE.GET_FAVORITE_FOLDER_REQUEST));
    getFavoriteFolderListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_FAVORITE_FOLDER_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_FAVORITE_FOLDER_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_FAVORITE_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addRemoveFavoriteFolderList(data, token, onAddFavFolder) {
  return (dispatch) => {
    dispatch(request(FILE.ADD_REMOVE_FAVORITE_FOLDER_REQUEST));
    addAndRemoveFromMyFavFolderApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.ADD_REMOVE_FAVORITE_FOLDER_SUCCESS, data));
          if (onAddFavFolder) {
            onAddFavFolder(res.data.data);
          }
        } else {
          dispatch(
            failure(FILE.ADD_REMOVE_FAVORITE_FOLDER_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.ADD_REMOVE_FAVORITE_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteFolder(id, token, onDeleteFolder) {
  return (dispatch) => {
    dispatch(request(FILE.DELETE_FOLDER_REQUEST));
    deleteFolderApi(id, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.DELETE_FOLDER_SUCCESS, id));
          if (onDeleteFolder) {
            onDeleteFolder();
          }
        } else {
          dispatch(failure(FILE.DELETE_FOLDER_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.DELETE_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getDeletedFolderList(data, token, Notification) {
  return (dispatch) => {
    dispatch(request(FILE.GET_DELETED_FOLDER_REQUEST));
    getDeletedFolderListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_DELETED_FOLDER_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_DELETED_FOLDER_FAILURE, res.data.message));
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_DELETED_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getAllFilesList(data, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(FILE.GET_FILE_REQUEST));
    getFilesListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_FILE_SUCCESS, res.data.data));
          if (moveToNext) {
            moveToNext(res.data.data);
          }
        } else {
          dispatch(failure(FILE.GET_FILE_FAILURE, res.data.data));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addFileList(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(FILE.ADD_FILE_REQUEST));
    addFileListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.ADD_FILE_SUCCESS, res.data.data));
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(failure(FILE.ADD_FILE_FAILURE, res.data.message));
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.ADD_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getRecentFileList(data, token) {
  return (dispatch) => {
    dispatch(request(FILE.GET_RECENT_FILE_REQUEST));
    getRecentFileListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_RECENT_FILE_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_RECENT_FILE_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_RECENT_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteFile(id, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(FILE.DELETE_FILE_REQUEST));
    deleteFileApi(id, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.DELETE_FILE_SUCCESS, id));
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(failure(FILE.DELETE_FILE_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.DELETE_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getDeletedFileList(data, token, Notification) {
  return (dispatch) => {
    dispatch(request(FILE.GET_DELETED_FILE_REQUEST));
    getDeletedFileListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_DELETED_FILE_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_DELETED_FILE_FAILURE, res.data.message));
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_DELETED_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getFavoriteFileList(data, token) {
  return (dispatch) => {
    dispatch(request(FILE.GET_FAVORITE_FILE_REQUEST));
    getFavoriteFileListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.GET_FAVORITE_FILE_SUCCESS, res.data.data));
        } else {
          dispatch(failure(FILE.GET_FAVORITE_FILE_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.GET_FAVORITE_FILE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addRemoveFavoriteFileList(data, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(FILE.ADD_REMOVE_FAVORITE_FILE_REQUEST));
    addAndRemoveFromMyFavFileApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(FILE.ADD_REMOVE_FAVORITE_FILE_SUCCESS, data));
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(
            failure(FILE.ADD_REMOVE_FAVORITE_FILE_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FILE.ADD_REMOVE_FAVORITE_FOLDER_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
